import { IconFromSet, IconValue } from '@gettactic/components';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Image } from 'react-konva';
import { Furniture } from '../../furniture-list';

export interface IconToolGhostItemProps {
  icon: IconValue;
}

export interface FurnitureToolGhostItemProps {
  furniture: Furniture;
}

export type SvgGhostItemProps =
  | IconToolGhostItemProps
  | FurnitureToolGhostItemProps;

export const SvgGhostItem = React.forwardRef<
  React.ElementRef<typeof Image>,
  SvgGhostItemProps
>((props, ref) => {
  const [konvaImage, setKonvaImage] = React.useState<HTMLImageElement | null>(
    null
  );

  const selectedIcon = (props as IconToolGhostItemProps).icon;
  const selectedFurniture = (props as FurnitureToolGhostItemProps).furniture;

  React.useEffect(() => {
    if (!selectedIcon && !selectedFurniture) return;
    setKonvaImage(null);
    const img = new window.Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const image = new window.Image();
      image.src = canvas.toDataURL('image/png');
      image.onload = () => {
        setKonvaImage(image);
      };
    };

    if (selectedIcon) {
      const svgString = ReactDOMServer.renderToStaticMarkup(
        <IconFromSet icon={selectedIcon} size={64} />
      );

      img.src =
        'data:image/svg+xml;base64,' +
        btoa(unescape(encodeURIComponent(svgString)));

      return;
    }

    if (selectedFurniture) {
      img.src = selectedFurniture.url;
    }
  }, [selectedIcon, selectedFurniture]);

  if (!konvaImage) return null;

  return (
    <Image
      image={konvaImage || undefined}
      width={20}
      height={20}
      scaleX={1}
      scaleY={1}
      x={100}
      y={100}
      ref={ref}
    />
  );
});
